/**
 * Simple token store for accessing the auth token outside of React context.
 * This is used by the API module which is a singleton and cannot use hooks.
 */
let currentToken = null;

/**
 * Sets the current token.
 *
 * @param {string|null} token - The token to store.
 */
export const setToken = (token) => {
    currentToken = token;
};

/**
 * Gets the current token.
 *
 * @returns {string|null} The current token.
 */
export const getToken = () => {
    return currentToken;
};
